import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiMapPin, FiShield } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Circle of Goodness<sup className="text-xs">TM</sup>
            </h3>
            <p className="text-gray-400 mb-4">
              Empowering entrepreneurs with the tools, training, and community they need to build thriving businesses.
            </p>
            <div className="flex items-center text-sm text-gray-400">
              <SafeIcon icon={FiShield} className="mr-2" />
              100% Secure & Trusted
            </div>
          </div>

          {/* Quick links */}
          <div>
            <h4 className="font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-gray-400">
              <li>
                <a 
                  href="https://www.consciousgrowthinternational.com/about" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white transition-colors"
                >
                  About Us
                </a>
              </li>
              <li>
                <a 
                  href="https://www.consciousgrowthinternational.com/blog/" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white transition-colors"
                >
                  Blog
                </a>
              </li>
              <li>
                <a 
                  href="https://www.consciousgrowthinternational.com/privacy-policy" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>

          {/* Empty column for spacing */}
          <div></div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-4">Contact</h4>
            <div className="space-y-3 text-gray-400">
              <div className="flex items-center">
                <SafeIcon icon={FiMail} className="mr-3" />
                <span>info@consciousgrowthinternational.com</span>
              </div>
              <div className="flex items-center">
                <SafeIcon icon={FiMapPin} className="mr-3" />
                <span>Available Worldwide</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 Circle of Goodness<sup className="text-xs">TM</sup>. All rights reserved.</p>
          <p className="mt-2 text-sm">
            Transform your business • Build your community • Create your success
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;